//

export const messageTypeObj = {
  text: 'text',
  media: 'media',
  draftjs: 'draftjs',
};
